import { Box, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export default function ProductsTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const value = pathname.startsWith('/analytics/products/ms') ? 'ms' : 'mp';

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={value}
        onChange={(_, next) => navigate(next === 'ms' ? '/analytics/products/ms' : '/analytics/products')}
      >
        <Tab value="mp" label="Товары МП" />
        <Tab value="ms" label="Товары МС" />
      </Tabs>
    </Box>
  );
}
